// Picker posizione su mappa Leaflet con click
import { useState, useCallback, useEffect } from 'react'
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet'
import L from 'leaflet'
// Usa coords locali (lat/lng) — @fieldcore/types usa latitude/longitude
interface Coords { lat: number; lng: number }
import { cn } from '../../lib/utils'

// Fix icona Leaflet con webpack/vite
delete (L.Icon.Default.prototype as unknown as Record<string, unknown>)._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
})

interface ClickHandlerProps {
  onClick: (coords: Coords) => void
}

function ClickHandler({ onClick }: ClickHandlerProps) {
  useMapEvents({
    click: (e) => {
      onClick({ lat: e.latlng.lat, lng: e.latlng.lng })
    },
  })
  return null
}

// Sposta la vista quando le coordinate del centro cambiano
function RecenterMap({ center, zoom }: { center: Coords; zoom: number }) {
  const map = useMap()
  useEffect(() => {
    map.flyTo([center.lat, center.lng], zoom, { duration: 0.8 })
  }, [center.lat, center.lng, zoom, map])
  return null
}

interface MapPickerProps {
  value?: Coords | null
  onChange: (coords: Coords) => void
  className?: string
  height?: string
  zoom?: number
  center?: Coords
}

export function MapPicker({
  value,
  onChange,
  className,
  height = '300px',
  zoom = 10,
  center = { lat: 41.9028, lng: 12.4964 }, // Roma come default
}: MapPickerProps) {
  const [position, setPosition] = useState<Coords | null>(value ?? null)

  const handleClick = useCallback(
    (coords: Coords) => {
      setPosition(coords)
      onChange(coords)
    },
    [onChange]
  )

  return (
    <div className={cn('overflow-hidden rounded-lg border border-[var(--fc-border)]', className)}>
      <MapContainer
        center={[center.lat, center.lng]}
        zoom={zoom}
        style={{ height, width: '100%' }}
        className="z-0"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <RecenterMap center={center} zoom={zoom} />
        <ClickHandler onClick={handleClick} />
        {position && (
          <Marker position={[position.lat, position.lng]} />
        )}
      </MapContainer>
      {position && (
        <div className="flex items-center gap-2 border-t border-[var(--fc-border)] bg-[var(--fc-surface-raised)] px-3 py-2 text-xs text-[var(--fc-foreground-muted)]">
          <span>Lat: {position.lat.toFixed(6)}</span>
          <span>Lng: {position.lng.toFixed(6)}</span>
        </div>
      )}
    </div>
  )
}
